export default __webpack_public_path__ + "static/media/516.cfd48cfe.png";